import axios from 'axios';
import postal from 'postal';
import {
  recordSoundcloudPlayStartStatistic,
  recordSoundcloudPlayFinishedStatistic,
} from '../services/statistics-service';

export default function bootstrap() {
  $(() => {
    const registerIFrame = iframe => {
      const widget = SC.Widget(iframe);
      const wireId = $(iframe).parents('article.wire').data().id;

      widget.bind(SC.Widget.Events.PLAY, () => {
        // Check to see if this media is restricted by Digital Pass
        if ($('.restricted-by-digital-pass').length) {
          widget.pause();
          return;
        }

        recordSoundcloudPlayStartStatistic(wireId);
      });
      widget.bind(SC.Widget.Events.FINISH, () => recordSoundcloudPlayFinishedStatistic(wireId));
    };

    function register($div) {
      const { soundcloudUrl: url } = $div.data();

      const params = {
        url,
        format: 'json',
        maxheight: 166,
      };

      axios.get('//soundcloud.com/oembed', { params, crossDomain: true }).then(response => {
        /* global SC */
        $div.html(response.data.html);

        const iframe = $div.find('iframe')[0];
        const widget = SC.Widget(iframe);
        const wireId = $div.parents('article.wire').data().id;

        widget.load(url, {
          visual: false,
        });

        widget.bind(SC.Widget.Events.PLAY, () => {
          // Check to see if this media is restricted by Digital Pass
          if ($('.restricted-by-digital-pass').length) {
            widget.pause();
            return;
          }

          recordSoundcloudPlayStartStatistic(wireId);
        });
        widget.bind(SC.Widget.Events.FINISH, () => recordSoundcloudPlayFinishedStatistic(wireId));
      });
    }

    $('[data-soundcloud-url]').each((index, div) => register($(div)));
    document.querySelectorAll("iframe[src*='/soundcloud.com/']").forEach(iframe => registerIFrame(iframe));

    postal.subscribe({
      channel: 'commands.soundcloud',
      topic: 'register-soundcloud-embed',
      callback: data => register($(data.div)),
    });
  });
}
